import React from 'react'
import {GridColDef} from '@mui/x-data-grid'
import {Button, Chip} from '@mui/material'
import Device, {DeviceStatus, STATUS_CHIP_COLOR, STATUS_LABEL} from 'models/Device'

export const createDeviceColumns = (
  onClickEdit: (device: Device) => void,
  onClickDelete: (deviceId: string) => void,
  onClickLookup: (device: Device) => void,
) => {
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Id',
      flex: 1,
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'udid',
      headerName: 'UDID',
      flex: 1,
    },
    {
      field: 'patient',
      headerName: 'Patient Id',
      valueGetter: params => params.row.patient?.id,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: params => {
        const status: DeviceStatus = params.row.status
        return <Chip size="small" label={STATUS_LABEL[status]} color={STATUS_CHIP_COLOR[status]} />
      },
    },

    {
      field: 'actions',
      headerName: '',
      hideable: false,
      disableColumnMenu: true,
      type: 'actions',
      width: 300,
      renderCell: params => (
        <>
          <Button variant="contained" onClick={() => onClickEdit(params.row)}>
            Edit
          </Button>
          <Button
            sx={{marginLeft: 2}}
            onClick={() => onClickDelete(params.id.toString())}
            variant="contained"
            color="error">
            Delete
          </Button>
          <Button
            sx={{marginLeft: 2}}
            onClick={() => onClickLookup(params.row)}
            variant="outlined">
            Details
          </Button>
        </>
      ),
    },
  ]
  return columns
}
